import PropTypes from 'prop-types';
import React from 'react';

const Button = props => {
  const {content, href} = props;
  const onClick = e => {
    e.preventDefault();
    window.open(href, 'window', 'left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
    return false;
  };
  return (
    <a className='btn btn--icon' href={href} onClick={onClick}>
      {content}
    </a>
  );
};

Button.propTypes = {
  content: PropTypes.string,
  href: PropTypes.string
};

const SharingButtons = props => {
  const {message, url} = props;
  return (
    <div className='calculator__sharing'>
      <h3 className='calculator__sharing__title'>
        Share Your Vision
      </h3>
      <div className='btn-group'>
        <Button href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} content='Facebook' />
        <Button href={`https://twitter.com/intent/tweet?text=${message}&url=${url}`} content='Twitter' />
      </div>
    </div>
  );
};

SharingButtons.propTypes = {
  message: PropTypes.string,
  url: PropTypes.string
};

export default SharingButtons;
